// ═══════════════════════════════════════════════════════════════
// PRODUCT GRID — Quick Add, Qty Selector, Quick View
// Added: Aug 2026
// ═══════════════════════════════════════════════════════════════
(function() {
  if (window.gridActionsInit) return;
  window.gridActionsInit = true;

  // Qty selector buttons (event delegation)
  document.addEventListener('click', function(e) {
    var minus = e.target.closest('[data-grid-qty-minus]');
    var plus = e.target.closest('[data-grid-qty-plus]');

    if (minus) {
      e.preventDefault();
      var wrapper = minus.closest('.grid-product__qty');
      var input = wrapper.querySelector('[data-grid-qty]');
      var v = parseInt(input.value) || 1;
      if (v > 1) {
        input.value = v - 1;
        updateHiddenQty(minus);
      }
    }

    if (plus) {
      e.preventDefault();
      var wrapper = plus.closest('.grid-product__qty');
      var input = wrapper.querySelector('[data-grid-qty]');
      input.value = (parseInt(input.value) || 1) + 1;
      updateHiddenQty(plus);
    }
  });

  function updateHiddenQty(el) {
    var actions = el.closest('[data-grid-actions]');
    if (!actions) return;
    var hidden = actions.querySelector('[data-grid-qty-hidden]');
    var visible = actions.querySelector('[data-grid-qty]');
    if (hidden && visible) hidden.value = visible.value;
  }

  // Qty input change
  document.addEventListener('change', function(e) {
    if (e.target.matches('[data-grid-qty]')) {
      updateHiddenQty(e.target);
    }
  });

  // Quick add to cart via AJAX
  document.addEventListener('submit', function(e) {
    if (!e.target.matches('[data-grid-cart-form]')) return;

    // Let the theme's cart drawer handle it if available
    // Only intercept if theme JS doesn't catch it
    var form = e.target;
    var formData = new FormData(form);

    // Check if theme has a cart drawer (Impulse theme)
    if (window.theme && window.theme.settings && window.theme.settings.cartType === 'drawer') {
      // Let the theme JS handle it — don't prevent default
      return;
    }

    // Fallback: AJAX add to cart
    e.preventDefault();
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function(r) { return r.json(); })
      .then(function() {
        // Redirect to cart or show message
        window.location.href = '/cart';
      })
      .catch(function(err) {
        console.error('Add to cart error:', err);
      });
  });
})();
